module.exports = __webpack_public_path__ + "img/PorQue_Desktop@2x.d5c9018.webp";